export enum UpdateOptions {
  UNI = 'UNI',
  LightUpdate = 'Light Update'
}
